import './App.css';
import { useState } from "react";
import cn from 'classnames';

const notes = [
  'до', 'ре', 'ми', 'фа', 'соль', 'ля', 'си'
];

export function shuffle(a) {
  for (let i = a.length - 1; i > 0; i--) {
    const j = Math.floor(Math.random() * (i + 1));
    [a[i], a[j]] = [a[j], a[i]];
  }
  return a;
}

function inputNumberFormatter(str) {
  let value = str;
  if (value[0] === '.') {
    value = `0${value}`;
  }

  value = value
    .replace(/[^0-9.,]/g, '')
    .replace(/,/g, '.')
    // remove leading zeros
    .replace(/^0+(\d)/g, '$1');

  value = value.split('.')[0];

  const split = value.split('.');
  if (split.length > 2) {
    value = `${split[0]}.${split.slice(1).join('')}`;
  } else if (split[1] && split[1].length > 2) {
    value = `${split[0]}.${split[1].substring(0, 2)}`;
  }
  return value;
}

function App() {
  const [firstNode, setFirstNode] = useState('');
  const [randomNotes, setRandomNotes] = useState([]);
  const [selected, setSelected] = useState([]);
  const [internal, setInternal] = useState('');
  const [correctSequence, setCorrectSequence] = useState([]);
  const [step, setStep] = useState('');
  const [direction, setDirection] = useState('forward');
  const [finalDirection, setFinalDirection] = useState('');

  const handleGenerate = () => {
    const start = shuffle([...notes])[0];
    setFirstNode(start);
    setSelected([]);
    setStep('');

    const interval = parseInt(internal || '0', 10);
    const stepSize = interval + 1;
    const startIndex = notes.indexOf(start);

    // Определяем реальное направление
    let dir = direction;
    if (direction === 'random') {
      dir = Math.random() > 0.5 ? 'forward' : 'backward';
    }
    setFinalDirection(dir);

    let seq = [start];
    let currentIndex = startIndex;

    if (dir === 'forward') {
      // Идем вперед
      while (true) {
        currentIndex = (currentIndex + stepSize) % notes.length;
        seq.push(notes[currentIndex]);
        if (currentIndex === startIndex) {
          break;
        }
      }
    } else {
      // Идем назад
      while (true) {
        currentIndex = (currentIndex - stepSize + notes.length) % notes.length;
        seq.push(notes[currentIndex]);
        if (currentIndex === startIndex) {
          break;
        }
      }
    }

    setCorrectSequence(seq.slice(1));
    setRandomNotes(shuffle([...notes]));
  };

  const checkResult = () => {
    if (
      selected.length === correctSequence.length &&
      selected.every((note, index) => note === correctSequence[index])
    ) {
      setStep('good');
    } else {
      setStep('fail');
    }
  };

  function renderDirectionHint() {
    if (finalDirection === 'forward') {
      return <p>Отгадывайте ноты <b>слева направо →</b></p>;
    } else if (finalDirection === 'backward') {
      return <p>Отгадывайте ноты <b>← справа налево</b></p>;
    } else {
      return null;
    }
  }

  function renderContent() {
    if (step === 'fail') {
      return (
        <>
          <h1>Неправильно!</h1>
          <h4>Правильная последовательность:</h4>
          <div className="note_items">
            {correctSequence.map(note => (
              <div
                className="note_item"
                key={note}
              >{note}</div>
            ))}
          </div>
        </>
      );
    } else if (step === 'good') {
      return (
        <h1>Правильно!</h1>
      );
    } else {
      return (
        <>
          <h3>Выберите ноты в правильном порядке</h3>
          <div className="note_items">
            {randomNotes.map(note => (
              <div
                className={cn({
                  note_item: true,
                  note_item_selected: selected.indexOf(note) > -1,
                })}
                key={note}
                onClick={() => {
                  setSelected(prev => [...prev, note]);
                }}
              >{note}</div>
            ))}
          </div>
          <h3>Ваш результат</h3>
          <div className="note_items">
            <div className="note_item">{firstNode}</div>
            {selected.map(note => (
              <div
                className="note_item"
                key={note}
                onClick={() => {
                  setSelected(prev => prev.filter(item => item !== note))
                }}
              >{note}</div>
            ))}
          </div>
          {renderDirectionHint()}
          <div>
            <button onClick={checkResult} className="form_button" style={{ marginTop: 16, marginLeft: 0 }}>Проверить</button>
          </div>
          <p>
            Выбирайте ноты по порядку до тех пор, пока снова не достигнете <b>{firstNode}</b>. Чтобы усложнить задание, можно указать интервал: например, через одну или две ноты.
          </p>
        </>
      );
    }
  }

  return (
    <div className="App">
      <div className="form">
        <input
          value={internal}
          onChange={(e) => setInternal(inputNumberFormatter(e.target.value.trim()))}
          type="number" placeholder="Интервал (0)" className="form_input" />

        <select
          className="form_input"
          style={{ marginLeft: 8 }}
          value={direction}
          onChange={(e) => setDirection(e.target.value)}
        >
          <option value="forward">Вперед</option>
          <option value="backward">Назад</option>
          <option value="random">Случайно</option>
        </select>

        <div style={{ marginTop: 10 }}>
          <button className="form_button" onClick={handleGenerate}>Генерировать</button>
        </div>
      </div>
      {correctSequence.length > 0 && (
        <div className="game">
          {renderContent()}
        </div>
      )}
    </div>
  );
}

export default App;
